<template>
  <div class="container">
    <div class="activity" v-for="item in activitylist">
      <div class="activity_img">
        <div
          id=""
          style="
            width: 100%;
            height: 133px;
            overflow: hidden;
            display: flex;
            justify-content: center;
          "
        >
          <img :src="item.imageurl" style="width: auto" />
        </div>

        <div class="activity_end" v-show="item.time < timestamp1">已结束</div>
      </div>
      <div class="activity_text">
        <div class="activity_title">{{ item.title }}</div>
        <div class="activity_time">
          <img src="../assets/activity_time.png" />
          <div>{{ item.starttime }}-{{ item.endtime }}</div>
        </div>
        <div class="activity_time">
          <img src="../assets/activity_dizhi.png" />
          <div>{{ item.address }}</div>
        </div>
        <div v-if="item.time < timestamp1" class="activity_btn_cli">已结束</div>
        <div v-else="" class="activity_btn" @click="sctivity_cli(item.taid)">
          立即预约
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { wclient } from "../../static/wclient-mobile.js";
export default {
  name: "ActivityRegistration",
  data() {
    return {
      baseUrl: "",
      activitylist: [],
      taid: "",
      timestamp1: "",
      baseUrlOne: "",
    };
  },
  methods: {
    sctivity_cli(id) {
      var that = this;
      sessionStorage.setItem("taid", id);
      sessionStorage.setItem("orderType", "0");
      that.$router.push({
        name: "DetailsActivities",
      });
    },
	getUrlKey (name) {
        return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null
    },
    // GetRequest() {
    //   var url = location.search; //获取url中"?"符后的字串
    //   var theRequest = new Object();
    //   if (url.indexOf("?") != -1) {
    //     var str = url.substr(1);
    //     strs = str.split("&");
    //     for (var i = 0; i < strs.length; i++) {
    //       theRequest[strs[i].split("=")[0]] = unescape(strs[i].split("=")[1]);
    //     }
    //   }
    //   return theRequest;
    // },
  },
  mounted() {
    var that = this;
    var publicUrl = window.location.hostname;
    if (publicUrl == "localhost") {
      var baseUrl = "https://www.xiangshan1949.cn";
      var baseUrlOne = "http://xs.weapi.org";
    } else if (publicUrl == "m.xs.weapi.org") {
      var baseUrl = "https://www.xiangshan1949.cn";
      var baseUrlOne = "http://xs.weapi.org";
    } else {
      var baseUrl = "https://www.xiangshan1949.cn";
      var baseUrlOne = "https://www.xiangshan1949.cn";
    }
    that.baseUrl = baseUrl;
    that.baseUrlOne = baseUrlOne;
    // var Request = that.GetRequest();
	var access_token=this.getUrlKey('access_token')
	console.log(access_token)
    if (access_token!=null) {
      $.ajax({
        type: "GET",
        url: that.baseUrlOne + "/ajax?ugi=loginUgi&action=logininfo",
        dataType: "json",
        async: true,
        data: {
          access_token: access_token,
        },
        success: function (data) {
          if (data.code == "A00006") {
            sessionStorage.setItem("appointment_type", "activity");
            wclient.view.showLoading();
            that.$http
              .get(
                that.baseUrl +
                  "/tickets/tickets/ajax?ugi=ticketactivity&action=getActivityList&sponsorid=a0df565fe509435eba413105fc9a006c&moduleid=TICKETS&categoryid=90dec8d3b36e412495465b49a0f02fb0",
                {}
              )
              .then(function (res) {
                wclient.view.hideLoading();
                that.activitylist = res.data.activitylist;
                that.timestamp1 = Date.parse(new Date());
                for (var i = 0; i < that.activitylist.length; i++) {
                  that.$set(
                    that.activitylist[i],
                    "time",
                    Date.parse(that.activitylist[i].endtime)
                  );
                }
              })
              .catch(function (err) {
                console.log(err);
              });
          } else {
            sessionStorage.setItem("token_type", "activity");
            that.$router.push({
              name: "Logo",
            });
          }
        },
      });
    } else {
      if (localStorage.getItem("access_token") == null) {
        sessionStorage.setItem("token_type", "activity");
        that.$router.push({
          name: "Logo",
        });
      } else {
        $.ajax({
          type: "GET",
          url: that.baseUrlOne + "/ajax?ugi=loginUgi&action=logininfo",
          dataType: "json",
          async: true,
          data: {
            access_token: localStorage.getItem("access_token"),
          },
          success: function (data) {
            if (data.code == "A00006") {
              sessionStorage.setItem("appointment_type", "activity");
              wclient.view.showLoading();
              that.$http
                .get(
                  that.baseUrl +
                    "/tickets/tickets/ajax?ugi=ticketactivity&action=getActivityList&sponsorid=a0df565fe509435eba413105fc9a006c&moduleid=TICKETS&categoryid=90dec8d3b36e412495465b49a0f02fb0",
                  {}
                )
                .then(function (res) {
                  wclient.view.hideLoading();
                  that.activitylist = res.data.activitylist;
                  that.timestamp1 = Date.parse(new Date());
                  for (var i = 0; i < that.activitylist.length; i++) {
                    that.$set(
                      that.activitylist[i],
                      "time",
                      Date.parse(that.activitylist[i].endtime)
                    );
                  }
                })
                .catch(function (err) {
                  console.log(err);
                });
            } else {
              sessionStorage.setItem("token_type", "activity");
              that.$router.push({
                name: "Logo",
              });
            }
          },
        });
      }
    }
  },
};
</script>

<style scoped>
body {
  width: 100%;
  background: white;
}

.container {
  width: 100%;
  -webkit-overflow-scrolling: touch;
}

.activity {
  width: 92%;
  margin-left: 4%;
  border-bottom: 1px solid rgba(212, 212, 212, 1);
  padding: 15px 0;
  display: flex;
  justify-content: space-between;
}

.activity_img {
  width: 33%;
  margin-right: 3%;
  position: relative;
}

.activity_end {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  left: 0;
  top: 0;
}

.activity_text {
  width: 64%;
}

.activity_title {
  font-weight: bold;
  color: rgba(24, 24, 24, 1);
  line-height: 22px;
  font-size: 17px;
  margin-bottom: 10px;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-box-pack: center;
  -webkit-line-clamp: 2;
  overflow: hidden;
}

.activity_time {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 13px;
  font-weight: bold;
  color: rgba(173, 173, 173, 1);
  margin-bottom: 3px;
}

.activity_time img {
  width: 5%;
  margin-right: 3%;
  margin-top: -2px;
}

.activity_btn {
  margin-left: 70%;
  margin-top: 10px;
  width: 30%;
  text-align: center;
  line-height: 30px;
  font-size: 12px;
  background: linear-gradient(
    0deg,
    rgba(207, 18, 14, 1),
    rgba(207, 18, 14, 1),
    rgba(236, 107, 105, 1)
  );
  border-radius: 43px;
  color: white;
}

.activity_btn_cli {
  margin-left: 70%;
  margin-top: 10px;
  width: 30%;
  text-align: center;
  line-height: 30px;
  font-size: 12px;
  background: rgba(215, 215, 215, 1);
  border-radius: 43px;
  color: white;
}
</style>


// WEBPACK FOOTER //
// src/components/activityRegistration.vue